module.exports = __webpack_public_path__ + "static/media/pic4.720238df.jpg";